import {CONSTANTS} from "./constant";

export async function getDetailFromChartClick(folder, pdb, interactionType, record) {

    const postData = new FormData();
    postData.append("folder", folder);
    postData.append("pdb", pdb);
    postData.append("interactionType", interactionType);
    postData.append("chain1", record[3]);
    postData.append("chain2", record[6]);
    postData.append("chain1Idx", record[2]);
    postData.append("chain2Idx", record[5]);

    try {
        const response = await fetch(CONSTANTS.PHP_SCRIPT_BASE_PATH + 'get_details.php', {
            method: 'POST',
            body: postData
        });

        const result = await response.json();
        return result.data;

    } catch (error) {
        console.error('Errore durante la richiesta:', error);
    }
};